import React, {useState} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material';
import CheckCircle from '@mui/icons-material/CheckCircle';
import {FormWrapper, SuccessBox, SuccessDesc, SuccessTitle} from './styles';
import {useLandingContext} from "../../../Landing";
import {Loading} from "../../../../Loading";

export default function TrialModal({tariff_id, open, onClose}) {
    const {APP_DATA, onVKButtonClick, VKButton} = useLandingContext();
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        await onVKButtonClick(tariff_id);
        //setSubmitted(true);
        setLoading(false);
    };

    const handleReset = () => {
        setSubmitted(false);
        onClose();
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth
                paperprops={{style: {borderRadius: 20, padding: '10px'}}}>
            {loading && <Loading/>}
            {!submitted ? (
                <form onSubmit={handleSubmit}>
                    <DialogTitle style={{fontWeight: 700, fontSize: '18px', textAlign: 'center'}}>
                        {APP_DATA.ctaActivation}
                    </DialogTitle>
                    <DialogContent>
                        <FormWrapper>
                            <span style={{fontSize: '11px', color: '#64748b', textAlign: 'center'}}>
                            {APP_DATA.withoutCard}
                          </span>
                        </FormWrapper>
                    </DialogContent>
                    <DialogActions style={{padding: '0 24px 20px', justifyContent: 'center'}}>
                        <div>
                            <VKButton/>
                        </div>
                    </DialogActions>
                </form>
            ) : (
                <DialogContent>
                    <SuccessBox>
                        <CheckCircle color="success" sx={{fontSize: 56}}/>
                        <SuccessTitle>{APP_DATA.success}</SuccessTitle>
                        <SuccessDesc>
                            {APP_DATA.congratulation}
                        </SuccessDesc>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleReset}
                            style={{marginTop: '16px', borderRadius: 12, textTransform: 'none', fontWeight: 600}}
                            fullWidth
                        >
                            {APP_DATA.ok}
                        </Button>
                    </SuccessBox>
                </DialogContent>
            )}
        </Dialog>
    );
}
